import Spinner from '../elements/Spinner';
import styles from 'styles/components/common/overlays/Loading.module.scss';

const Loading = () => {
  return (
    <div className={styles.dimmed}>
      <Spinner />
    </div>
  );
};

export default Loading;
